import React, { useState, useEffect } from "react";
import { approvedUsers, addLicenseKey } from "../Services/AllServices";
import "../styles/ModeratorLicenseManagement.css";
import IDCardPopup from "./IDCardPopup";
import GenerateNewKeyPopup from "./generateNewKeyPopup";
import fullscreenIcon from "../images/full_screen.png";

const ModeratorLicenseManagement = () => {
  const [users, setUsers] = useState([]);
  const [openIDCardPopup, setOpenIDCardPopup] = useState(false);
  const [idCardUrl, setIdCardUrl] = useState("");

  // New states for handling the Generate License Key popup
  const [openGenerateKeyPopup, setOpenGenerateKeyPopup] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [licenseKey, setLicenseKey] = useState("");

  useEffect(() => {
    fetchAllUsers();
  }, []);

  const fetchAllUsers = () => {
    approvedUsers((response) => {
      console.log("API Response:", response);
      if (Array.isArray(response.data)) {
        const sortedUsers = response.data.sort((a, b) =>
          b._id.localeCompare(a._id)
        );
        setUsers(sortedUsers);
      } else {
        console.error("Data is not an array:", response);
      }
    });
  };

  // const formatDate = (dateString) => {
  //   if (!dateString) return "NA";
  //   const date = new Date(dateString);
  //   return date.toLocaleDateString("en-GB");
  // };

  const formatDate = (dateString) => {
    if (!dateString) return "NA";
    const date = new Date(dateString);
    // Adjust to local timezone using toLocaleDateString
    return date.toLocaleDateString("en-GB", { timeZone: "UTC" });
  };

  // const formatApiDate = (date) => {
  //   return date ? date.toISOString().split("T")[0] : null; // Format to YYYY-MM-DD
  // };

  const formatApiDate = (date) => {
    if (!date) return null;

    const localDate = new Date(date);
    // Set the time to 00:00:00 to avoid shifting the date
    localDate.setHours(0, 0, 0, 0);

    return localDate.toISOString().split("T")[0]; // Format to YYYY-MM-DD
  };

  const handleIDCardClick = (idCardUrl) => {
    setIdCardUrl(idCardUrl);
    setOpenIDCardPopup(true);
  };

  const isLicenseExpired = (endDate) => {
    if (!endDate) return false;
    const currentDate = new Date();
    const licenseEndDate = new Date(endDate);
    return licenseEndDate < currentDate;
  };

  // New function to handle Generate License Key button click
  const handleGenerateLicenseClick = (user) => {
    setSelectedUser(user);
    setOpenGenerateKeyPopup(true);
  };

  const handleApproveLicenseKey = (startDate, endDate) => {
    const payload = {
      user_id: selectedUser._id,
      licensekey: licenseKey,
      start_date: formatApiDate(startDate),
      end_date: formatApiDate(endDate),
    };
    console.log("startDate:", payload.start_date);

    addLicenseKey(payload, (response) => {
      console.log("gibberishaidjsfoiajhdoifhiodsF");
      console.log("Add License Key Response:", response);
      setOpenGenerateKeyPopup(false);
      fetchAllUsers(); // Refresh users list to reflect the updated license data
    });
  };

  return (
    <div className="user-management">
      <div className="users-container">
        <h1>License Management</h1>
        <h2>User's Licenses</h2>
        <div className="users-list">
          {Array.isArray(users) && users.length > 0 ? (
            users
              .filter((user) => user.profile === "Teacher")
              .map((user) => (
                <div
                  key={user._id}
                  className={`user-card ${user.status?.toLowerCase()}`}
                >
                  <div className="user-list-left">
                    <div
                      className="teacher_id"
                      onClick={() => handleIDCardClick(user.ID_card.url)}
                    >
                      <img src={user.ID_card.url} alt="id card" />
                      <div className="fullscreen-icon-container">
                        <img src={fullscreenIcon} alt="Full Screen" />
                      </div>
                    </div>
                  </div>
                  <div className="user_details">
                    <div className="user_name_role">
                      <div className="user_name">{user.name}</div>
                      <div className="user_role">
                        {user.profile} {user.role && `- ${user.role}`}
                      </div>
                      {user.requestnewkey &&
                        user.requestnewkey.toLowerCase() === "yes" && (
                          <div
                            className="requested-license"
                          >
                            Requested New License
                          </div>
                        )}
                    </div>
                    <div className="user_license_details">
                      <div className="license_start_date">
                        <div className="start_date_text">Start Date &nbsp;</div>
                        <div className="start_date">
                          {" "}
                          - &nbsp;
                          {user.licenseStartDate
                            ? formatDate(user.licenseStartDate)
                            : "NA"}
                        </div>
                      </div>
                      <div className="license_end_date">
                        <div className="end_date_text">End Date &nbsp;</div>
                        <div className="end_date">
                          {" "}
                          - &nbsp;
                          {user.licenseEndDate
                            ? formatDate(user.licenseEndDate)
                            : "NA"}
                        </div>
                      </div>
                      <div className="license_key_container">
                        <div className="license_key_text">
                          License Key &nbsp;
                        </div>
                        <div className="license_key">
                          {" "}
                          - &nbsp;{user.licensekey || "NA"}
                        </div>
                      </div>
                      {user.licensekey && (
                        <div
                          className="license_key_status"
                          style={{
                            background: isLicenseExpired(user.licenseEndDate)
                              ? "#FD5454"
                              : "#00B69B",
                          }}
                        >
                          <div className="key_status">
                            {isLicenseExpired(user.licenseEndDate)
                              ? "Expired"
                              : "Active"}{" "}
                            &nbsp;
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="generate_license">
                    <div className="generate_license_box">
                     <button
                        className="generate_license_text"
                        onClick={() => handleGenerateLicenseClick(user)} // Pass user object
                        disabled={!isLicenseExpired(user.licenseEndDate)} // Disable if license is not expired
                        style={{
                          cursor: isLicenseExpired(user.licenseEndDate) ? "pointer" : "not-allowed",
                        }}
                      >
                        Generate License Key
                      </button>
                    </div>
                  </div>
                </div>
              ))
          ) : (
            <p>No user's licenses found.</p>
          )}
        </div>
        <IDCardPopup
          open={openIDCardPopup}
          idCardUrl={idCardUrl}
          onClose={() => setOpenIDCardPopup(false)}
        />
        <GenerateNewKeyPopup
          open={openGenerateKeyPopup}
          userProfile={selectedUser?.profile}
          licenseKey={licenseKey}
          onLicenseKeyChange={setLicenseKey}
          onClose={() => setOpenGenerateKeyPopup(false)}
          onApprove={(startDate, endDate) =>
            handleApproveLicenseKey(startDate, endDate)
          } // Pass dates for the API call
        />
      </div>
    </div>
  );
};

export default ModeratorLicenseManagement;
